<apcam-shared-dialog-shell [config]="dialogShellConfig">
    <div class="@container">
        <div class="flex flex-col @sm:flex-row gap-4">
            <div class="flex justify-center">
                <mat-icon
                    [color]="iconColor"
                    role="img"
                    aria-hidden="false"
                    attr.aria-label="{{ 'shared.icons.warning' | translate }}"
                    class="text-5xl! h-12! w-12!">
                    warning_amber
                </mat-icon>
            </div>
            <div class="space-y-[1lh]">
                @for (p of paragraphs; track $index) {
                    <p>{{ p }}</p>
                }
            </div>
        </div>
    </div>
</apcam-shared-dialog-shell>
